<template>
    <div class="tabsContainer" style="overflow-x: auto; -webkit-overflow-scrolling: touch; margin-top:20px;">
        <div class="tabList" role="tablist" id="tablist">
            <div class="tab-nav">
                <router-link
                    v-for="tab in tabItems"
                    :key="tab.key"
                    :to="tab.to"
                    :class="['tabButton', isActiveTab(tab) ? 'active' : '']">
                    <span><span>{{ tab.label }}</span></span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    address: String
  },
  computed: {
    tabItems() {
      const base = `/address/${this.address}`
      return [
        //{ key: 'transactions', label: 'Transactions', to: base },
        { key: 'transfers', label: 'Transfers', to: `${base}/transfers` },
        //{ key: 'internal', label: 'Internal txns', to: `${base}/internal-transactions` },
        //{ key: 'freeze', label: 'Staking Details', to: `${base}/freeze` },
        //{ key: 'contracts', label: 'Contracts Published', to: `${base}/contracts` },
        //{ key: 'analysis', label: 'Analysis', to: `${base}/analysis` },
        //{ key: 'permissions', label: 'Account Permission', to: `${base}/permissions` }
      ]
    }
  },
  methods: {
    isActiveTab(tab) {
        const currentPath = this.$route.path;
        const tabPath = tab.to;
        
        //if (tab.key === 'transfers') {
        //    return currentPath === tabPath;
        //}        
        
        return currentPath.startsWith(tabPath);
    }
  }
}
</script>

<style src="@/assets/styles/address.css" lang="css"></style>
<style src="@/assets/styles/address.1109.css" lang="css"></style>
<style src="@/assets/styles/address.1224.css" lang="css"></style>
<style src="@/assets/styles/address.1965.css" lang="css"></style>
<style src="@/assets/styles/address.2162.css" lang="css"></style>
<style src="@/assets/styles/address.3027.css" lang="css"></style>
<style src="@/assets/styles/address.4846.css" lang="css"></style>
<style src="@/assets/styles/address.5148.css" lang="css"></style>
<style src="@/assets/styles/address.7563.css" lang="css"></style>
<style src="@/assets/styles/address.9803.css" lang="css"></style>
<style src="@/assets/styles/iconfont.css" lang="css"></style>

<style>
    
    .tabsContainer .tabList {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
    }

    .tabsContainer .tabList .tab-nav {
        display: flex;
        gap: 12px;
    }

    .tabsContainer .tabButton.active, .tabsContainer .tabButton:hover {
        background-color: #101010;
        color: #fff !important;
        transition: all .35s;
    }
    .tabsContainer .tabButton {
        background-color: #ecedf0;
        border: none;
        border-radius: 8px;
        color: #73787b;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        padding: 7px 20px;
        transition: all .35s;
        white-space: nowrap;
    }
</style>